export default __webpack_public_path__ + "static/media/Andrea Scanzi.04fe9470.jpg";